var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-toolbar',{attrs:{"color":"primary","fixed":"","dark":"","app":"","clipped-right":""}},[_c('v-icon',{attrs:{"dark":""},on:{"click":_vm.goBack}},[_vm._v("close")]),_vm._v("\n       \n    "),_c('v-toolbar-title',[_vm._v(_vm._s(this.title))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }